import { ProfileProps } from '@design-system/global-header';
import { useProfile } from '@phx-husky/use-profile';
import { useUserSession } from '@phx-husky/use-user-session';
import { navigate } from 'gatsby';
import React from 'react';

import { useAutocomplete } from '~/hooks/useAutocomplete';
import { extendedHeaderMapper } from '~/mappers/header/extendedHeaderMapper';
import { ExtendedHeaderBasic, Profile } from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

import { ExtendedGlobalHeader } from '../ExtendedGlobalHeader';

const HeaderWrapWithProfile = ({
  extendedHeaderBasic,
  profile,
}: {
  extendedHeaderBasic?: ExtendedHeaderBasic | null;
  profile?: Profile;
}) => {
  const { autocompleteState, getInputProps } = useAutocomplete();

  const extendedMapper = extendedHeaderMapper({
    extendedHeaderBasic,
    profile,
  });

  const { isSignedIn, signOut } = useUserSession();
  const { getUserName } = useProfile();

  const handleNavigateWithRefresh = (link: string) => {
    navigate(link, { replace: true, state: { timestamp: Date.now() } });
  };

  return extendedMapper ? (
    <ExtendedGlobalHeader
      {...{
        ...extendedMapper,
        profile: {
          ...extendedMapper.profile,
          signedIn: isSignedIn(),
          handleSignOut: () => signOut(),
          handleLogIn: () =>
            handleNavigateWithRefresh(extendedMapper.profile!.logIn.link),
          handleRegister: () =>
            handleNavigateWithRefresh(extendedMapper.profile!.register.link),
          userName: getUserName().userName,
        } as ProfileProps,
        search: extendedMapper.search
          ? {
              ...extendedMapper.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  ) : null;
};

export default HeaderWrapWithProfile;
